/** Auto-generated by scripts/stamp-version.mjs — do not edit by hand at deploy time. */
export const APP_VERSION = {
  "buildId": "build-1793694453576",
  "version": "21.0.0",
  "builtAt": "2026-11-03T08:27:33.576Z"
} as const;
